export default class WatchedProductsController {
    constructor($scope, $http, $attrs, toast) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.toast = toast;

        this.selectedWatchedProducts = {};
        this.subject = null;
        this.watchedId = $attrs.watchedId;
        this.displayForm = !!this.watchedId;

        if (this.watchedId) {
            this.selectedWatchedProducts[this.watchedId] = true;
        }
    }

    get hasWatchedProductsSelected() {
        return !!Object.values(this.selectedWatchedProducts)
            .filter(value => value === true)
            .length;
    }

    sendEnquiry() {

    }
}
